/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file getExecutionIds selector
 * @author Roland Scott
 * @module react-async-hook\internal\state\selectors\get-execution-ids
 */

import { IAsyncState } from "../../";

/**
 * Get the list of execution ids from the state, sorted oldest to newest.
 * @param state The async state
 */
export function getExecutionIds(state: IAsyncState): number[] {
	if (!state) {
		throw Error("State not defined.");
	}
	if (!state.ids) {
		throw Error("IDs not defined.");
	}
	return state.ids;
}
